module.exports = __webpack_public_path__ + "img/ico_mine_tab@3x.389f5e74.png";